import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";
const faqs = [{
  question: "¿Funciona si solo tengo ITIN y no SSN?",
  answer: "¡Absolutamente! El sistema está diseñado específicamente para latinos con ITIN. De hecho, muchos de nuestros casos de éxito más impresionantes son de personas que construyeron excelente crédito usando solo su ITIN. El módulo 2 cubre esto en detalle."
}, {
  question: "¿Cuánto tiempo toma ver resultados?",
  answer: "La mayoría de nuestros estudiantes ven mejoras en su score entre 30-90 días. Algunos han reportado aumentos de 50+ puntos en solo 30 días aplicando las técnicas del módulo 4. Los resultados varían según tu situación inicial."
}, {
  question: "¿Es diferente a las empresas de reparación de crédito?",
  answer: "Sí, muy diferente. Las empresas de reparación de crédito te cobran $1,000+ y hacen todo por ti (a veces de manera cuestionable). Crédito Libre te enseña a hacerlo tú mismo, de forma legal y permanente. Además, pagas una sola vez por acceso de por vida."
}, {
  question: "¿Qué pasa si no me funciona?",
  answer: "Tienes una garantía de 60 días. Si aplicas el sistema y no ves mejoras en tu crédito, simplemente solicitas un reembolso completo a través de Hotmart. Sin preguntas, sin complicaciones."
}, {
  question: "¿Está en español?",
  answer: "¡Sí! Todo el contenido está 100% en español, diseñado específicamente para la comunidad latina en Estados Unidos. Las plantillas de cartas también incluyen versiones en inglés para enviar a los bureaus y bancos."
}, {
  question: "¿Recibo acceso inmediato?",
  answer: "Sí, una vez que completas tu compra a través de Hotmart, recibes acceso instantáneo al sistema completo. Puedes empezar a estudiar y aplicar las estrategias de inmediato."
}, {
  question: "¿Hay actualizaciones incluidas?",
  answer: "Sí, tu compra incluye todas las actualizaciones futuras sin costo adicional. Cuando agreguemos nuevas estrategias, plantillas o recursos, tendrás acceso automático."
}, {
  question: "¿Puedo acceder desde mi celular?",
  answer: "Sí, el sistema es 100% digital y accesible desde cualquier dispositivo: celular, tablet o computadora. Puedes estudiar cuando y donde quieras."
}];
const FAQSection = () => {
  const handleBuyClick = () => {
    window.open(HOTMART_CHECKOUT_URL, "_blank");
  };
  return <section className="relative overflow-hidden section-padding bg-[hsl(215,12%,40%)]">
      {/* Background dots pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)`,
        backgroundSize: '20px 20px'
      }} />
      </div>
      <div className="container-centered relative z-10">
        {/* Section Header */}
        <div className="mb-10 text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2">
            <HelpCircle className="h-5 w-5 text-primary" />
            <span className="text-sm font-semibold text-primary">FAQ</span>
          </div>
          <h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl lg:text-4xl">
            Preguntas{" "}
            <span className="text-primary">Frecuentes</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-primary-foreground font-bold">
            Resolvemos las dudas más comunes sobre Crédito Libre
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="rounded-xl border bg-card px-6 shadow-soft">
                <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-card-foreground hover:text-primary hover:no-underline sm:text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-card-foreground/80">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        {/* CTA Final después de FAQ */}
        <div className="mt-12 rounded-2xl bg-card p-8 text-center shadow-card">
          <h3 className="font-display text-2xl font-bold text-secondary-foreground sm:text-3xl">
            ¿Listo para Transformar Tu Crédito?
          </h3>
          <p className="mt-3 text-muted-foreground">
            Únete a más de 1,547 latinos que ya lo lograron
          </p>
          
          <Button onClick={handleBuyClick} size="lg" className="mt-6 btn-cta relative h-16 gradient-cta px-10 text-lg font-bold text-white shadow-glow transition-all hover:scale-105 animate-pulse-glow">
            
            <span className="text-center whitespace-normal">¡SÍ, QUIERO EMPEZAR HOY! - $16.99</span>
          </Button>
          
          <div className="mt-4 flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <ShieldCheck className="h-4 w-4 text-primary" />
            Garantía de 60 días - Sin riesgo
          </div>
          
          <p className="mt-6 text-muted-foreground">
            ¿Tienes más preguntas?{" "}
            <a href="#" className="font-semibold text-primary underline underline-offset-4 hover:text-primary/80">
              Contáctanos
            </a>
          </p>
        </div>
      </div>
    </section>;
};
export default FAQSection;